import {Card, CardContent, CardHeader, Divider, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React, {useState} from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {T} from 'react-polyglot-hooks';
import {Payment} from '../../../graphql/payments.datatypes';
import PaymentEditModal from '../../Payments/PaymentEditModal';
import getUnbalancedPayments from './getUnbalancedPayments.api';
import Results from '../../Payments/PaymentsList/Results';

const useStyles = makeStyles(() => ({
    root: {},
    content: {
        padding: 0
    },
    inner: {
        minWidth: 800
    },
    actions: {
        justifyContent: 'flex-end'
    }
}));

const UnbalancedPayments = (props: { className?: string }) => {
    const {className, ...rest} = props;
    const classes = useStyles();
    const [selectedPayment, setSelectedPayment] = useState<Payment | null>(null);
    const paymentsData = getUnbalancedPayments();

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardHeader title="Unbalanced Payments"/>
            <Divider/>
            <CardContent className={classes.content}>
                <PerfectScrollbar>
                    <div className={classes.inner}>
                        {paymentsData.loading && (
                            <Typography><T phrase="Loading..."/></Typography>
                        )}
                        {!paymentsData.loading &&
                        paymentsData.data &&
                        paymentsData.data.getUnbalancedPayments && (
                            <Results
                                payments={paymentsData.data.getUnbalancedPayments}
                                setSelectedPayment={setSelectedPayment}
                            />
                        )}
                    </div>
                </PerfectScrollbar>
            </CardContent>

            {selectedPayment && (
                <PaymentEditModal onClose={() => setSelectedPayment(null)}
                                  open={true} payment={selectedPayment} setSelectedPayment={setSelectedPayment}
                                  isAdmin={true} canEdit={true}/>
            )}
        </Card>
    );
};

export default UnbalancedPayments;
